export default __webpack_public_path__ + "img/117ac392928caf95f1df7f513dfa058f.svg";